var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAzadi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 36,
    viewBox: "0 0 67 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3089 24.0001H4.86533L4.22902 25.5233H3.03125L6.02566 18.7988H7.186L10.143 25.5233H8.90779L8.3089 24.0001ZM7.85974 22.997L6.58712 20.0248L5.31449 22.997H7.85974Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.672 20.4336V21.1766L11.715 24.6317H14.7468V25.5234H10.3301V24.7803L13.2871 21.3252H10.4424V20.4336H14.672Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7137 25.5225V24.8909C18.3394 25.3367 17.7406 25.5596 16.992 25.5596C15.8691 25.5596 15.1953 24.8909 15.1953 23.9621C15.1953 23.0333 15.9065 22.4389 17.1417 22.4389H18.7137V22.2903C18.7137 21.6587 18.302 21.25 17.4786 21.25C16.992 21.25 16.4679 21.4358 15.9439 21.7702L15.4948 20.99C16.2059 20.5813 16.7299 20.3584 17.7031 20.3584C19.0132 20.3584 19.7618 21.0271 19.7992 22.1417V25.4853H18.7137V25.5225ZM18.7137 23.7392V23.2562H17.3288C16.6177 23.2562 16.2808 23.442 16.2808 23.925C16.2808 24.3708 16.6551 24.668 17.2914 24.668C18.04 24.7051 18.6389 24.2965 18.7137 23.7392Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9759 18.3897V25.5228H24.853V24.6312C24.4787 25.2256 23.8798 25.56 23.0563 25.56C21.5591 25.56 20.5859 24.4826 20.5859 22.9222C20.5859 21.399 21.5966 20.3216 23.0189 20.3216C23.8424 20.3216 24.4787 20.6559 24.853 21.2504V18.3525H25.9759V18.3897ZM24.853 22.9965C24.853 21.9934 24.2167 21.3247 23.2809 21.3247C22.3452 21.3247 21.7088 22.0306 21.7088 22.9965C21.7088 23.9624 22.3452 24.6683 23.2809 24.6683C24.2167 24.6683 24.853 23.9624 24.853 22.9965Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6343 18.9471C28.6343 19.3186 28.3348 19.6158 27.998 19.6158C27.6611 19.6158 27.3242 19.3186 27.3242 18.9471C27.3242 18.5755 27.6237 18.2783 27.9605 18.2783C28.2974 18.2783 28.6343 18.5755 28.6343 18.9471ZM28.522 20.4331V25.5601H27.3991V20.4331H28.522Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 8.02441L17.0687 10.5136L17.5927 11.1823L18.0793 11.8882L17.4804 11.2938L16.8441 10.6993L14.748 8.02441Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7969 7.31934L17.4438 10.2915L17.7807 11.1088L18.0801 11.889L17.631 11.146L17.1818 10.4401L15.7969 7.31934Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9941 6.94727L17.8925 10.2166L17.9673 11.034L18.0796 11.8884L17.8176 11.0711L17.5556 10.2538L16.9941 6.94727Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3033 6.87305V10.2167L18.1911 11.0712L18.0788 11.8885L18.0413 11.034L18.0039 10.2167L18.3033 6.87305Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5773 7.16992L18.7164 10.365L18.4169 11.108L18.0801 11.8882L18.2672 11.0709L18.4169 10.2535L19.5773 7.16992Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7376 7.76465L19.0907 10.5882L18.6041 11.2569L18.0801 11.8885L18.4544 11.1455L18.8287 10.4396L20.7376 7.76465Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7108 8.65625L19.3901 10.9225L18.7538 11.4055L18.0801 11.8884L18.6415 11.294L19.203 10.6996L21.7108 8.65625Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4594 9.7334L19.6147 11.3309L18.8287 11.591L18.0801 11.8882L18.7913 11.4424L19.465 11.0337L22.4594 9.7334Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9086 10.9971L19.727 11.7401L18.9035 11.8144L18.0801 11.8887L18.8661 11.6658L19.6521 11.4429L22.9086 10.9971Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0209 12.2973L19.727 12.1859L18.9035 12.0373L18.0801 11.8887H18.9035H19.727L23.0209 12.2973Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7963 13.5976L19.6147 12.5946L18.8287 12.2602L18.0801 11.8887L18.9035 12.1116L19.6896 12.2973L22.7963 13.5976Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2723 14.7494L19.3901 12.9661L18.7538 12.4088L18.0801 11.8887L18.8287 12.2973L19.5399 12.706L22.2723 14.7494Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4488 15.7153L19.0907 13.2633L18.5667 12.5574L18.0801 11.8887L18.679 12.4831L19.3153 13.0775L21.4488 15.7153Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3633 16.4583L18.7164 13.449L18.3795 12.6689L18.0801 11.8887L18.5292 12.5946L18.9784 13.3376L20.3633 16.4583Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1656 16.8298L18.3047 13.5605L18.1924 12.706L18.0801 11.8887L18.3421 12.706L18.6041 13.4862L19.1656 16.8298Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8555 16.9042V13.5233L17.9678 12.706L18.08 11.8887L18.1175 12.706L18.1549 13.5605L17.8555 16.9042Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.582 16.6069L17.4429 13.4119L17.7798 12.6317L18.0792 11.8887L17.8921 12.706L17.7424 13.5233L16.582 16.6069Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4219 16.0125L17.0688 13.1518L17.5928 12.5203L18.0794 11.8887L17.7051 12.5946L17.3308 13.3376L15.4219 16.0125Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4492 15.1209L16.7699 12.8546L17.4436 12.3716L18.0799 11.8887L17.5185 12.4831L16.9945 13.0775L14.4492 15.1209Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6992 14.0063L16.5439 12.4459L17.3299 12.1859L18.0785 11.8887L17.4048 12.2973L16.6936 12.7432L13.6992 14.0063Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 12.7803L16.4316 12.0373L17.255 11.963L18.0785 11.8887L17.2925 12.1116L16.5064 12.3345L13.25 12.7803Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1387 11.4424L16.4325 11.591L17.256 11.7396L18.0795 11.8882H17.256H16.4325L13.1387 11.4424Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3633 10.1797L16.5448 11.1828L17.3309 11.5171L18.0795 11.8887L17.256 11.6658L16.47 11.48L13.3633 10.1797Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9238 8.99023L16.7685 10.8107L17.4423 11.3308L18.0786 11.8881L17.33 11.4794L16.6188 11.0707L13.9238 8.99023Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3573 7.13343C16.4696 7.05912 16.6193 7.13342 16.6941 7.24488C16.769 7.35634 16.6941 7.50494 16.5818 7.57925C16.4696 7.65355 16.3198 7.57925 16.245 7.46779C16.1701 7.31918 16.245 7.17058 16.3573 7.13343Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5929 6.8735C17.7427 6.83635 17.8549 6.9478 17.8924 7.05926C17.9298 7.20786 17.8549 7.31932 17.7052 7.35647C17.5555 7.39362 17.4432 7.28217 17.4058 7.17071C17.3683 7.0221 17.4806 6.91065 17.5929 6.8735Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9026 6.98438C19.0524 6.98438 19.1272 7.13298 19.1272 7.24444C19.1272 7.39305 19.0149 7.5045 18.8652 7.46735C18.7155 7.46735 18.6406 7.31874 18.6406 7.20729C18.6406 7.05868 18.7529 6.98438 18.9026 6.98438Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1002 7.43052C20.2125 7.46767 20.2873 7.61628 20.2499 7.76488C20.2125 7.87634 20.0628 7.95064 19.9505 7.91349C19.8382 7.87634 19.7633 7.72773 19.8008 7.57912C19.8382 7.43052 19.9879 7.35621 20.1002 7.43052Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2235 8.1732C21.3358 8.24751 21.3732 8.39611 21.2983 8.50757C21.2235 8.61902 21.0738 8.65618 20.9615 8.58187C20.8492 8.50757 20.8117 8.35896 20.8866 8.24751C20.924 8.0989 21.1112 8.06175 21.2235 8.1732Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0844 9.13972C22.1967 9.25117 22.1593 9.39978 22.0844 9.51123C21.9721 9.58554 21.8224 9.58554 21.7476 9.47408C21.6727 9.36263 21.6727 9.21402 21.7476 9.10257C21.8224 9.02826 22.0096 9.02826 22.0844 9.13972Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6824 10.3279C22.7573 10.4393 22.6824 10.588 22.5701 10.6623C22.4578 10.7366 22.3081 10.6623 22.2333 10.5508C22.1584 10.4393 22.2333 10.2907 22.3455 10.2164C22.4953 10.1421 22.645 10.2164 22.6824 10.3279Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9825 11.6284C23.0199 11.777 22.945 11.8884 22.7953 11.9256C22.6456 11.9627 22.5333 11.8513 22.4959 11.7398C22.4584 11.5912 22.5333 11.4797 22.683 11.4426C22.8327 11.3683 22.945 11.4797 22.9825 11.6284Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9456 12.929C22.9456 13.0776 22.8333 13.1519 22.6836 13.1519C22.5338 13.1519 22.459 13.0033 22.459 12.8919C22.459 12.7432 22.5713 12.6689 22.721 12.6689C22.8333 12.6689 22.9456 12.7804 22.9456 12.929Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5702 14.1546C22.5328 14.3032 22.3831 14.3403 22.2708 14.3032C22.1585 14.266 22.0836 14.1174 22.1211 13.9688C22.1585 13.8574 22.3082 13.7831 22.4205 13.8202C22.5328 13.8574 22.6077 14.006 22.5702 14.1546Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8979 15.2324C21.8231 15.3439 21.6734 15.381 21.5611 15.3067C21.4488 15.2324 21.4114 15.0838 21.4862 14.9723C21.5611 14.8609 21.7108 14.8237 21.8231 14.898C21.9354 14.9723 21.9728 15.1209 21.8979 15.2324Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9614 16.0864C20.8491 16.1607 20.6994 16.1607 20.6245 16.0493C20.5496 15.9378 20.5496 15.7892 20.6245 15.6778C20.7368 15.6035 20.8865 15.6035 20.9614 15.7149C21.0737 15.8264 21.0362 15.975 20.9614 16.0864Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8006 16.6437C19.6883 16.718 19.5386 16.6437 19.4637 16.5322C19.3889 16.4208 19.4637 16.2722 19.576 16.1979C19.6883 16.1236 19.838 16.1979 19.9129 16.3093C19.9877 16.4208 19.9503 16.5694 19.8006 16.6437Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5668 16.8672C18.4171 16.9044 18.3048 16.7929 18.2674 16.6815C18.2299 16.5328 18.3048 16.4214 18.4545 16.3842C18.6042 16.3471 18.7165 16.4585 18.7539 16.57C18.7914 16.7186 18.6791 16.8672 18.5668 16.8672Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2929 16.7925C17.1432 16.7925 17.0684 16.6439 17.0684 16.5325C17.0684 16.3839 17.1807 16.3096 17.3304 16.3096C17.4801 16.3096 17.555 16.4582 17.555 16.5696C17.5175 16.6811 17.4052 16.7925 17.2929 16.7925Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6683 11.4061C17.9303 11.1832 18.3046 11.2204 18.5666 11.4804C18.7912 11.7405 18.7912 12.1492 18.5291 12.3721C18.2671 12.595 17.8928 12.5578 17.6308 12.2978C17.4062 12.0377 17.4062 11.629 17.6683 11.4061Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8593 8.54504C20.3246 6.76176 17.8917 6.24163 15.9453 7.09612V7.54194C17.7794 6.6503 20.1001 7.13328 21.5973 8.8051C23.3565 10.8484 23.2442 13.8949 21.2978 15.6039C19.8006 16.9413 17.6671 17.0528 15.9453 16.124V16.5698C17.7794 17.4986 19.9878 17.3128 21.5598 15.9382C23.6185 14.0063 23.7682 10.737 21.8593 8.54504Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1835 27.8636L33.3868 25.4858L32.4511 26.4889V27.8636H31.5527V22.4766H32.4511V25.2629L35.0337 22.4766H36.1192L34.0231 24.78L36.2689 27.8636H35.1835Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3385 27.8631V27.3802C39.0391 27.7517 38.5525 27.9374 37.991 27.9374C37.0927 27.9374 36.5312 27.3802 36.5312 26.6743C36.5312 25.9313 37.0927 25.4483 38.1033 25.4483H39.3385V25.2625C39.3385 24.7424 39.0016 24.4452 38.3653 24.4452C37.9536 24.4452 37.5419 24.5938 37.1301 24.8539L36.7558 24.2223C37.3173 23.8879 37.7664 23.7021 38.5151 23.7021C39.5631 23.7021 40.162 24.2223 40.1994 25.1511V27.826H39.3385V27.8631ZM39.3385 26.4142V26.0427H38.2156C37.6167 26.0427 37.3547 26.1913 37.3547 26.6C37.3547 26.9715 37.6542 27.1944 38.1407 27.1944C38.8145 27.1944 39.3011 26.86 39.3385 26.4142Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6291 29.2383L26.8749 33.6965L29.1207 29.2383H30.4682V35.9627H29.4201V30.9473L27.2866 35.2569H26.538L24.3296 30.9473V35.9627H23.2441V29.2383H24.6291Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.997 35.9629V35.3313C34.6227 35.7772 34.0238 36.0001 33.2752 36.0001C32.1523 36.0001 31.4785 35.3313 31.4785 34.4025C31.4785 33.4737 32.1897 32.8793 33.4249 32.8793H34.997V32.7307C34.997 32.0991 34.5852 31.6905 33.7618 31.6905C33.2752 31.6905 32.7511 31.8762 32.2271 32.2106L31.778 31.4304C32.4891 31.0217 33.0132 30.7988 33.9863 30.7988C35.2964 30.7988 36.045 31.4676 36.0824 32.5821V35.9258H34.997V35.9629ZM34.997 34.1796V33.6967H33.612C32.9009 33.6967 32.564 33.8824 32.564 34.3654C32.564 34.8112 32.9383 35.1084 33.5746 35.1084C34.3232 35.1456 34.9595 34.7369 34.997 34.1796Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3334 32.7682V35.9632H41.2105V33.1025C41.2105 32.3223 40.7613 31.8765 39.9753 31.8765C39.0395 31.8765 38.5155 32.5824 38.5155 33.474V36.0004H37.3926V28.8301H38.5155V31.8394C38.8898 31.1335 39.5261 30.7991 40.4244 30.7991C41.6222 30.7991 42.3334 31.5793 42.3334 32.7682Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5091 33.3994C48.5091 34.9598 47.4236 36.0001 45.8141 36.0001C44.2046 36.0001 43.1191 34.9598 43.1191 33.3994C43.1191 31.8762 44.2046 30.7988 45.8141 30.7988C47.3862 30.7988 48.5091 31.8762 48.5091 33.3994ZM44.242 33.4366C44.242 34.4397 44.8784 35.1084 45.8141 35.1084C46.7499 35.1084 47.3862 34.4397 47.3862 33.4366C47.3862 32.4707 46.7499 31.7648 45.8141 31.7648C44.8784 31.7648 44.242 32.4335 44.242 33.4366Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3283 35.6289C51.9166 35.8518 51.5049 36.0004 51.0557 36.0004C50.2697 36.0004 49.5959 35.5546 49.5959 34.5143V31.8766H48.8848V31.0592H49.5959V29.6475H50.7188V31.0592H52.2535V31.8766H50.7188V34.3286C50.7188 34.8487 50.906 35.0345 51.2803 35.0345C51.5049 35.0345 51.7669 34.9602 52.0663 34.8115L52.3283 35.6289Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5723 31.6904C54.1232 31.6904 53.8237 31.839 53.8237 32.2105C53.8237 33.1393 56.5561 32.6564 56.5561 34.514C56.5561 35.5542 55.6204 36.0372 54.5723 36.0372C53.8237 36.0372 53.0003 35.7771 52.5137 35.3313L52.9254 34.5511C53.3746 34.9598 54.0857 35.1827 54.6472 35.1827C55.1338 35.1827 55.5081 35.0341 55.5081 34.6254C55.5081 33.5852 52.8131 34.1796 52.8131 32.322C52.8131 31.2818 53.7114 30.8359 54.7221 30.8359C55.3584 30.8359 56.0695 31.0217 56.5187 31.3561L56.107 32.1734C55.5829 31.8762 55.0215 31.6904 54.5723 31.6904Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5243 35.9629V35.3313C60.15 35.7772 59.5511 36.0001 58.8025 36.0001C57.6796 36.0001 57.0059 35.3313 57.0059 34.4025C57.0059 33.4737 57.717 32.8793 58.9522 32.8793H60.5243V32.7307C60.5243 32.0991 60.1126 31.6905 59.2891 31.6905C58.8025 31.6905 58.2785 31.8762 57.7545 32.2106L57.3053 31.4304C58.0165 31.0217 58.5405 30.7988 59.5137 30.7988C60.8237 30.7988 61.5723 31.4676 61.6098 32.5821V35.9258H60.5243V35.9629ZM60.4869 34.1796V33.6967H59.1019C58.3908 33.6967 58.0539 33.8824 58.0539 34.3654C58.0539 34.8112 58.4282 35.1084 59.0645 35.1084C59.8506 35.1456 60.4494 34.7369 60.4869 34.1796Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0705 30.8359L64.4928 34.8483L65.9152 30.8359H67.0381L65.0543 35.9629H63.894L61.9102 30.8359H63.0705Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19218 32.0243H1.45978L0.935754 33.2503H0L2.39553 27.8633H3.33128L5.68939 33.2503H4.7162L4.19218 32.0243ZM3.85531 31.2069L2.84469 28.8292L1.79665 31.2069H3.85531Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0633 30.6874V33.2509H12.1649V30.9475C12.1649 30.3159 11.7906 29.9444 11.1917 29.9444C10.4806 29.9815 10.0688 30.5017 10.0688 31.2075V33.2137H9.17052V30.9103C9.17052 30.2787 8.79621 29.9072 8.19733 29.9072C7.48616 29.9444 7.037 30.4645 7.037 31.1704V33.1766H6.13867V29.0899H7.037V29.8701C7.33644 29.2756 7.86046 29.0527 8.5342 29.0527C9.28281 29.0527 9.7694 29.4243 9.95655 30.0558C10.2186 29.3871 10.78 29.0527 11.5286 29.0527C12.5018 29.127 13.0633 29.7215 13.0633 30.6874Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3949 29.127V29.9814C15.5714 29.9443 15.0474 30.4273 14.9725 31.1331V33.2879H14.0742V29.2013H14.9725V30.0186C15.2346 29.4242 15.7211 29.127 16.3949 29.127Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8918 27.9752C17.8918 28.2724 17.6672 28.4953 17.3678 28.4953C17.0683 28.4953 16.8438 28.2724 16.8438 27.9752C16.8438 27.678 17.0683 27.4551 17.3678 27.4551C17.6672 27.4551 17.8918 27.678 17.8918 27.9752ZM17.8169 29.1641V33.2507H16.9186V29.1641H17.8169Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2601 32.9908C20.9232 33.1766 20.5863 33.288 20.2495 33.288C19.6131 33.288 19.0891 32.9165 19.0891 32.0992V29.9815H18.4902V29.3128H19.0891V28.1982H19.9874V29.3128H21.2226V29.9815H19.9874V31.9506C19.9874 32.3592 20.1372 32.5078 20.4366 32.5078C20.6238 32.5078 20.8109 32.4335 21.0729 32.3221L21.2601 32.9908Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1606 5.72163C53.8611 5.57302 53.674 5.68448 53.4494 5.79593C51.5779 6.65042 49.7064 6.61327 47.7226 6.01884C46.1505 5.57302 44.541 5.16435 42.8941 5.01575C39.9371 4.75568 37.317 5.79593 34.7717 7.05909C33.6488 7.61636 32.5634 8.21079 31.3282 8.50801C30.2427 8.76807 29.831 8.32225 30.0555 7.24485C30.2427 6.31606 30.0181 5.94454 29.1198 5.64732C28.8952 5.57302 28.6332 5.49872 28.3712 5.46157C25.2271 5.09005 22.1203 5.53587 19.0511 6.2789L18.7891 6.39036C18.7891 6.39036 22.2326 6.16745 23.7298 9.17674C25.6388 8.87952 27.5477 8.95383 29.4567 9.25104C30.2427 9.36249 30.5421 9.77116 30.2427 10.5513C30.1304 10.8486 30.0555 11.2201 30.0555 11.5544C29.9807 12.5575 30.4298 12.9662 31.4405 12.7433C31.7773 12.669 32.1142 12.5575 32.4136 12.4089C33.7986 11.7402 35.1835 11.1086 36.4561 10.2541C37.8036 9.32534 39.2634 8.73092 40.9477 8.58231C43.1561 8.3594 45.3645 8.50801 47.5729 8.4337C49.4818 8.3594 51.3907 8.13649 53.0002 6.98479C53.4494 6.61327 53.9734 6.31606 54.1606 5.72163Z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1609 12.6318C53.8615 12.4832 53.6743 12.5946 53.4498 12.7061C51.5783 13.5606 49.7067 13.5234 47.7229 12.929C46.1509 12.4832 44.5414 12.0745 42.8945 11.9259C39.9375 11.6658 37.3174 12.7061 34.7721 13.9692C33.6492 14.5265 32.5637 15.1209 31.3285 15.4182C30.2431 15.6782 29.8313 15.2324 30.0559 14.155C30.2431 13.2262 30.0185 12.8547 29.1202 12.5575C28.8956 12.4832 28.6336 12.4089 28.3716 12.3717C27.0615 12.2231 25.7514 12.186 24.4414 12.2974C24.404 12.7804 24.0297 15.2696 21.709 16.5327C22.0084 16.4584 22.2704 16.3841 22.5699 16.3098C24.8531 15.7897 27.1738 15.8268 29.4945 16.124C30.2805 16.2355 30.5799 16.6442 30.2805 17.4244C30.1682 17.7216 30.0933 18.0931 30.0933 18.4274C30.0185 19.4305 30.4676 19.8392 31.4783 19.6163C31.8151 19.542 32.152 19.4305 32.4514 19.2819C33.8364 18.6132 35.2213 17.9816 36.4939 17.1271C37.8414 16.1983 39.3012 15.6039 40.9855 15.4553C43.1939 15.2324 45.4023 15.381 47.6107 15.3067C49.5196 15.2324 51.4285 15.0095 53.038 13.8578C53.4498 13.5606 53.9738 13.2634 54.1609 12.6318Z",
    fill: "#00A24E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48047 0V1.48607H12.3888L4.90282 15.1207L6.10058 15.9752L15.0464 0H3.48047Z",
    fill: "#A08B63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.507 0H16.5824L11.5293 9.02786L12.6896 9.62229L17.331 1.48607H23.507V0Z",
    fill: "#A08B63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAzadi);
export default __webpack_public_path__ + "static/media/logo-azadi.9cdf5badf0c460375696b4eaf75ed621.svg";
export { ForwardRef as ReactComponent };